import React,{useState,useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import {useHistory } from "react-router-dom";

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
}));

export default function Navbar(props) {
  const classes = useStyles();
  const [display,setDisplay] = useState('block');
  
  const history = useHistory();
  useEffect(() => {
    // Update the document title using the browser API
    if(localStorage.getItem('token')==undefined){
      setDisplay('none')
    }
    
},[]);
  
  return (
    <div className={classes.root}>
      <AppBar position="fixed">
        <Toolbar>
          <Typography variant="h6" className={classes.title}>
            Simple Messenger Developed Using MERN + Socket.io 
          </Typography>
          <Button color="inherit" style={{display:display}} onClick={()=>{ localStorage.clear();history.push('/login') }}>Logout</Button> 
        </Toolbar>
      </AppBar>
    </div>
  );
}
